import React, { createContext, useContext, useMemo } from 'react';
import { selectedEnvironment } from '../config/config';

const LookupContext = createContext({
  disableAddLookup: false,
  editLookup: false,
});

export const useDisabledLookupContext = () => useContext(LookupContext);

const DisabledLookupContextProvider = ({ children }) => {
  const disabled = useMemo(() => selectedEnvironment !== 'production', []);
  const editLookup = useMemo(() => selectedEnvironment === 'production', []);
  return (
    <LookupContext.Provider value={{ disableAddLookup: disabled, editLookup }}>
      {children}
    </LookupContext.Provider>
  );
};

export default DisabledLookupContextProvider;
